// extracted by mini-css-extract-plugin
export default {"root":"Search_root__3eM1E","icon":"Search_icon__mET5i","input":"Search_input__PAAAO","clearIcon":"Search_clearIcon__ok5ti"};